import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from './Icon/X.png'
import _imports_1 from './Icon/Y.png'
import _imports_2 from './Icon/Z.png'
import _imports_3 from './Icon/regionSelection.png'
import _imports_4 from './Icon/lineSelection.png'
import _imports_5 from './Icon/trash.png'


const _hoisted_1 = {
  key: 0,
  class: "mode-compare-box"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "mode-compare-box-text-span mode-compare-box-mode-span"
}
const _hoisted_4 = {
  key: 1,
  class: "mode-compare-box-text-span mode-compare-box-date-span"
}
const _hoisted_5 = {
  key: 2,
  class: "mode-compare-three-dimension-control-panel"
}
const _hoisted_6 = { class: "three-dimension-control-panel-button-group" }
const _hoisted_7 = {
  key: 3,
  class: "mode-compare-three-dimension-level-panel custo-el-select"
}
const _hoisted_8 = { class: "mode-compare-box-text-color-box" }
const _hoisted_9 = ["id"]
const _hoisted_10 = {
  key: 1,
  class: "mode-compare-box-multiElement-text-color-box"
}
const _hoisted_11 = ["id"]
const _hoisted_12 = {
  key: 4,
  class: "mode-compare-box-color-bar"
}
const _hoisted_13 = { class: "split-color-bar-color-box" }
const _hoisted_14 = { class: "split-color-bar-color-box-item" }
const _hoisted_15 = { class: "split-color-code-options" }
const _hoisted_16 = { class: "split-color-code-options-item" }
const _hoisted_17 = { class: "color-code-item" }
const _hoisted_18 = { class: "color-bar-color-box" }
const _hoisted_19 = { class: "color-code-options" }
const _hoisted_20 = { class: "color-bar-color-box" }
const _hoisted_21 = { class: "color-code-options" }
const _hoisted_22 = {
  key: 0,
  class: "float-wind-text"
}

import { ref, onMounted, nextTick, onUnmounted, toRefs, watch } from "vue";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import { $Self } from "@/EventsBus";
import CustomLayer from "erayic-com-pack/encapsulation/layers/singleCustomLayer";
import { $Bus } from "erayic-com-pack/EventBus";
import { ElMessage } from "element-plus";
import * as ModeCompare from "./ModeCompare";
import { I_FactsColorBarItem, MapProps, NewMapListItem, ThreeModelOperation } from "./ModeComapare.type";
import { ModeCompareEvents } from "@/EventsBus/Apply/ModeCompareEvents";
import GrayImage, { GetBytesFromImage, GrayImageByValue, atmosphericPressure_to_height } from "erayic-com-pack/encapsulation/composables/useColorMap";
import { ClassThreeTextureModel } from "erayic-com-pack/component/ThreeScene/TextureModelClass";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { TextureEvents } from "erayic-com-pack/EventBus/Map/TextureEvents";
import { DateAdd, timeToString } from "erayic-com-pack/utils/timerToString";
import { calcSliceUrl, getSliceGridArray } from "erayic-com-pack/component/NewMap/NewMapLayer/SliceTextureLayer";
import singleCustomLayer from "erayic-com-pack/encapsulation/layers/singleCustomLayer";
import { loadImage, geojsonClip } from "../../views/SecondaryMenuList/ModelForecast/ModeForecast";


export default /*@__PURE__*/_defineComponent({
  __name: 'ModeCompare',
  props: {
    linearFillColor: { type: Boolean },
    heightSelectLevel: {},
    gridData: { type: Boolean },
    gridWind: { type: Boolean },
    flowLineDisplay: { type: Boolean },
    maskDisplay: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;
/** linearFillColor: 渐变填色状态; heightSelectLevel: 位势高度场状态, gridData: 格点状态, gridWind: 风羽状态, flowLineDisplay: 流线状态, maskDisplay: 遮罩状态  */
const { linearFillColor, heightSelectLevel, gridData, gridWind, flowLineDisplay, maskDisplay } = toRefs(props);

/** 展示状态 */
const displayStatus = ref<"single" | "compare" | "multiLevel" | "adjust" | "multiTime" | "multiElement" | "difference">("single");
/** 地图对象数组 */
const newMapList = ref<NewMapListItem[]>([]);
/** 地图默认属性 */
const mapProps = ref<MapProps>({ center: new mapboxgl.LngLat(109, 19), zoom: 6.5, pitch: 0, bearing: 0 });
/** 高度层可选项 */
const heightOption = ref();
/** 三维裁切绘制绑定变量 */
const mapboxDraw = ref(new MapboxDraw(ModeCompare.mapboxDrawParams));
/** 模式对比下的地图数量 */
const modeCompareMapNum = ref<number>(4);
/** 色标绑定对象 */
const colorThresholder = ref<{
  /** 阈值 */
  threshold: number,
  /** 色标长度(个) */
  length: number,
  /** 映射函数 */
  mappingFunc: (val: number) => number,
  /** 映射函数(带单位) */
  mappingFuncWithUnit: (val: number) => string,
  /** 色标值数组 */
  valueList: string[]
}>();
/** 高度截面状态 */
const isHeightCutting = ref<boolean>(false);

/** 透明度 */
const specifiedAlpha = ref<{ index: number, alpha: number }[]>([]);
/** 色标数组 */
const ColorBarData = ref<I_FactsColorBarItem>();
/** 多要素下的色标数组 */
const ColorBarDataList = ref<I_FactsColorBarItem[]>([]);

__expose({ ColorBarData });

onMounted(() => {
  $Bus.MapEvent.Texture.on('SliceTextureRenderingCompleted', TextureRenderingCompletedHandle);
  $Self.ApplyEvents.ModeCompare.on("SplitScreenHandle", SplitScreenHandle);
  $Self.ApplyEvents.ModeCompare.on("ExitSplitScreen", ExitSplitScreenHandle);
  $Self.ApplyEvents.ModeCompare.on("SplitScreenHeightField", SplitScreenHeightFieldHandle);
  $Self.ApplyEvents.ModeCompare.on("SplitScreenWindField", SplitScreenWindFieldHandle);
  $Self.ApplyEvents.ModeCompare.on("SplitScreenPositionSet", SplitScreenPositionSetHandle);
});

onUnmounted(() => {
  newMapList.value.forEach(item => { if (item.map) item.map.remove() });
  $Bus.MapEvent.Texture.off('SliceTextureRenderingCompleted', TextureRenderingCompletedHandle);
  $Self.ApplyEvents.ModeCompare.off("SplitScreenHandle", SplitScreenHandle);
  $Self.ApplyEvents.ModeCompare.off("ExitSplitScreen", ExitSplitScreenHandle);
  $Self.ApplyEvents.ModeCompare.off("SplitScreenHeightField", SplitScreenHeightFieldHandle);
  $Self.ApplyEvents.ModeCompare.off("SplitScreenWindField", SplitScreenWindFieldHandle);
  $Self.ApplyEvents.ModeCompare.off("SplitScreenPositionSet", SplitScreenPositionSetHandle);
});

// 监听状态改变
// 填色
watch(linearFillColor, (value) => {
  newMapList.value.forEach((item) => {
    item.sliceLayer.forEach((layer) => layer.changeVisualEffect(value ? 1 : 0));
  });
});
// 位势高度
watch(heightSelectLevel, (value) => {
  newMapList.value.forEach((item) => {
    if (item.map.getLayer("geoHeightLine"))
      item.map.setLayoutProperty("geoHeightLine", "visibility", value !== undefined ? "visible" : "none");
    if (item.map.getLayer("geoHeightText"))
      item.map.setLayoutProperty("geoHeightText", "visibility", value !== undefined ? "visible" : "none");
  });
});
// 格点
watch(gridData, (value) => {
  newMapList.value.forEach((item) => {
    if (value) refreshGrid(item.map, item.sliceLayer as singleCustomLayer[]);
    else {
      const source = item.map.getSource("GridDataSource");
      if (source) (source as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] });
    }
  });
});
// 风场
watch(gridWind, (value) => {
  newMapList.value.forEach((item, index) => {
    if (value) refreshWindField(item.map, index);
    else {
      const source = item.map.getSource("GridWindSource");
      if (source) (source as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] });
    }
  });
});
// 流线
watch(flowLineDisplay, (value) => {

});
// 遮罩状态
watch(maskDisplay, (value) => {
  MaskDisplayHandle(value);
});

// 修改遮罩显示状态
const MaskDisplayHandle = (tag: boolean) => {
  newMapList.value.forEach((item, index) => {
    if (gridData.value) refreshGrid(item.map, item.sliceLayer as singleCustomLayer[]);
    if (gridWind.value) refreshWindField(item.map, index);
  });

  newMapList.value.forEach(async (item) => {
    item.sliceLayer.forEach((layer) => { layer.changeMask(tag); });

    if (item.geoHeight && item.geoHeight.origin) {
      if (tag) {
        if (!item.geoHeight.clip) item.geoHeight.clip = await geojsonClip(item.geoHeight.origin, "IntelligentGrid");
        if (item.map.getSource("geoHeightSource"))
          (item.map.getSource("geoHeightSource") as mapboxgl.GeoJSONSource).setData(item.geoHeight.clip);
      } else if (item.map.getSource("geoHeightSource"))
        (item.map.getSource("geoHeightSource") as mapboxgl.GeoJSONSource).setData(item.geoHeight.origin);
    }
  });
};

// 风力等级固定值 用于在风力色标的特殊处理
const FixedWindLables = ["0", "5.5", "8", "10.8", "13.9", "17.2", "20.8", "24.5", "28.5", "32.7", "37", "41.5", "46.2", "51", "56.1"];
const FixedWindScale = ["≤3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "≥17"];
function TextureRenderingCompletedHandle(params: TextureEvents["SliceTextureRenderingCompleted"]) {
  if (displayStatus.value === "single" && params.LayerId !== ColorBarData.value?.id) {
    const codeLabels = Object.keys(params.ColorCodeData).sort((a: string, b: string) => parseFloat(a) - parseFloat(b));
    const codeValues: string[] = [];
    codeLabels.forEach(item => { codeValues.push(params.ColorCodeData[item]) });
    codeLabels.forEach((item, index) => {
      const num = parseFloat(item);
      if (!isNaN(num)) {
        const tempNum = parseFloat(num.toFixed(1));
        codeLabels[index] = tempNum % 1 === 0 ? tempNum.toFixed(0) : tempNum.toString();
      }
    });

    let FixedWindTag = false;
    if (params.Unit === "m/s") {
      let index = 0;
      while (index < codeLabels.length) {
        if (codeLabels[index] === FixedWindLables[index]) index++;
        else break;
      }
      if (index === codeLabels.length) FixedWindTag = true;
    }
    ColorBarData.value = {
      id: params.LayerId, codeKeys: codeLabels, codeColor: codeValues, colorOpacity: Array.from({ length: codeValues.length }, () => 1),
      unit: params.Unit, windLabels: FixedWindTag ? FixedWindScale : undefined
    };
  }
}

/** 监听绘制多分屏 */
const SplitScreenHandle = (params: ModeCompareEvents["SplitScreenHandle"]) => {
  displayStatus.value = params.display;
  const refreshTag = modeCompareMapNum.value === params.list.length || (params.list.length > 4 && modeCompareMapNum.value > 4); // 不触发resize情况下需要手动refreshSliceLayer
  modeCompareMapNum.value = params.list.length;

  // 已有地图组件
  if (newMapList.value.length) {
    // 移除多余地图
    if (newMapList.value.length > params.list.length) {
      for (let i = newMapList.value.length - 1; i >= params.list.length; i--) {
        newMapList.value[i].map.remove();
        newMapList.value.splice(i, 1);
      }
    }

    // 更新已有地图的信息  无需在此refreshSliceLayer 在之后的所有已有地图的resize中会触发moveend更新切片图层
    newMapList.value.forEach((item, i) => {
      if (item.sliceInfo.URL !== params.list[i].url) {
        item.sliceInfo = { URL: params.list[i].url, texClipParams: params.list[i].texClipParams, isNearest: params.isNearest };
        item.showText = (`${params.list[i].mode} -- ${timeToString(new Date(params.list[i].dataDate), "yyyy-MM-dd HH:00")} +` +
          (params.list[i].fcstDateScale < 10 ? "00" : (params.list[i].fcstDateScale < 100 ? "0" : "")) + params.list[i].fcstDateScale +
          `H(${timeToString(DateAdd("h", params.list[i].fcstDateScale, new Date(params.list[i].dataDate)), "ddHH")})`);
        item.bottomShowText = `${params.list[i].ele}(阴影)，${params.list[i].ele}(格点)`;
      }

      if (refreshTag) refreshSliceLayer({ target: newMapList.value[i].map }, i, displayStatus.value !== "multiElement" ? params.updateColorBar : true);
    });

    nextTick(async () => {
      for (let i = 0; i < newMapList.value.length; i++) newMapList.value[i].map.resize(); // 更新地图样式 触发refreshSliceLayer

      // 新增所需地图
      if (newMapList.value.length < params.list.length)
        for (let i = newMapList.value.length; i < params.list.length; i++)
          await ModeCompare.InitializeMap("mode-compare-map-" + i, mapProps).then((map) => {
            newMapList.value?.push({
              map, markerInfo: {}, sliceLayer: [], usedTexChannel: new Array(16).fill(false),
              sliceInfo: { URL: params.list[i].url, texClipParams: params.list[i].texClipParams, isNearest: params.isNearest },
              showText: (`${params.list[i].mode} -- ${timeToString(new Date(params.list[i].dataDate), "yyyy-MM-dd HH:00")} +` +
                (params.list[i].fcstDateScale < 10 ? "00" : (params.list[i].fcstDateScale < 100 ? "0" : "")) + params.list[i].fcstDateScale +
                `H(${timeToString(DateAdd("h", params.list[i].fcstDateScale, new Date(params.list[i].dataDate)), "ddHH")})`),
              bottomShowText: `${params.list[i].ele}(阴影)，${params.list[i].ele}(格点)`, windImage: []
            });

            // const markerDiv = document.createElement('div');
            // markerDiv.className = "ModeCompareMapMarker";
            // const marker = new mapboxgl.Marker(markerDiv).setLngLat([0, 0]).setOffset([45, 23]);
            // newMapList.value?.push({ map, markerInfo: { marker, markerDiv } });

            map.on("moveend", (e) => moveendHandle(e, i));
            map.on("load", () => {
              newMapList.value[i].map.on("moveend", (e) => refreshSliceLayer(e, i));
              refreshSliceLayer({ target: newMapList.value[i].map }, i, displayStatus.value !== "multiElement" ? params.updateColorBar : true);
            });
          });
    });
  } else // new 地图组件
    nextTick(() => {
      [...(new Array(modeCompareMapNum.value).keys())].forEach(async i => {
        ModeCompare.InitializeMap("mode-compare-map-" + i, mapProps).then((map) => {
          newMapList.value?.push({
            map, markerInfo: {}, sliceLayer: [], usedTexChannel: new Array(16).fill(false),
            sliceInfo: { URL: params.list[i].url, texClipParams: params.list[i].texClipParams, isNearest: params.isNearest },
            showText: (`${params.list[i].mode} -- ${timeToString(new Date(params.list[i].dataDate), "yyyy-MM-dd HH:00")} +` +
              (params.list[i].fcstDateScale < 10 ? "00" : (params.list[i].fcstDateScale < 100 ? "0" : "")) + params.list[i].fcstDateScale +
              `H(${timeToString(DateAdd("h", params.list[i].fcstDateScale, new Date(params.list[i].dataDate)), "ddHH")})`),
            bottomShowText: `${params.list[i].ele}(阴影)，${params.list[i].ele}(格点)`, windImage: []
          });

          // const markerDiv = document.createElement('div');
          // markerDiv.className = "ModeCompareMapMarker";
          // const marker = new mapboxgl.Marker(markerDiv).setLngLat([0, 0]).setOffset([45, 23]);
          // newMapList.value?.push({ map, markerInfo: { marker, markerDiv } });

          map.on("moveend", (e) => moveendHandle(e, i));
          map.on("load", () => {
            newMapList.value[i].map.on("moveend", (e) => refreshSliceLayer(e, i));
            refreshSliceLayer({ target: newMapList.value[i].map }, i, displayStatus.value !== "multiElement" ? params.updateColorBar : true);
          });
        });
      });
    });

  function moveendHandle(e: mapboxgl.MapboxEvent<MouseEvent | TouchEvent | WheelEvent | undefined> & mapboxgl.EventData, i: number) {
    if (e.originalEvent) {
      mapProps.value = { center: e.target.getCenter(), zoom: e.target.getZoom(), bearing: e.target.getBearing(), pitch: e.target.getPitch() };
      transformHandle(i, mapProps.value);
    }

    function transformHandle(self: number, params: { zoom: number, center: mapboxgl.LngLat, bearing: number, pitch: number }) {
      if (newMapList.value)
        newMapList.value.forEach((item, index) => {
          if (index !== self && !item.is3D) item.map.flyTo({
            center: params.center, zoom: params.zoom, bearing: params.bearing, pitch: params.pitch, speed: 2, easing: t => t
          });
        });
    }
  }
};

// 加载/更新格点
async function refreshGrid(map: mapboxgl.Map, currentLayer: singleCustomLayer[]) {
  const imageList: (GrayImage | GrayImageByValue)[] = [];
  for (let i = 0; i < currentLayer.length; i++)
    if (currentLayer[i] && currentLayer[i].image) imageList.push(currentLayer[i].image!);
  if (!imageList.length) return;

  const northeast = map.getBounds().getNorthEast();
  const southwest = map.getBounds().getSouthWest();

  let minLon: number = southwest.lng, maxLon: number = northeast.lng,
    minLat: number = southwest.lat, maxLat: number = northeast.lat;

  if (maskDisplay.value) {
    maxLon = maxLon > 120.35 ? 120.35 : maxLon;
    minLon = minLon < 106.1 ? 106.1 : minLon;
    maxLat = maxLat > 25 ? 25 : maxLat;
    minLat = minLat < 1.3 ? 1.3 : minLat;
  } else {
    maxLon = maxLon > 180 ? 180 : maxLon;
    minLon = minLon < 0 ? 0 : minLon;
    maxLat = maxLat > 90 ? 90 : maxLat;
    minLat = minLat < 0 ? 0 : minLat;
  }

  const leftUp = map.project([minLon, maxLat]);
  const rightDown = map.project([maxLon, minLat]);

  const FeatureCollection: GeoJSON.FeatureCollection<GeoJSON.Point, GeoJSON.GeoJsonProperties> = {
    type: "FeatureCollection",
    features: await getSliceGridArray({ minLat, maxLat, minLon, maxLon }, leftUp, rightDown, imageList[0].yInterval, imageList[0].xInterval,
      1000, imageList, false)
  };

  if (!map.getSource("GridDataSource")) {
    map.addSource("GridDataSource", { type: "geojson", data: FeatureCollection });
    map.addLayer({
      id: "GridDataLayer", source: "GridDataSource", type: "symbol",
      paint: { "text-color": "black", "text-halo-color": "white", "text-halo-width": 1 },
      layout: { "text-field": ["coalesce", ["get", "value"], ''], "text-size": 12, "text-allow-overlap": true }
    });
  } else
    (map.getSource("GridDataSource") as mapboxgl.GeoJSONSource).setData(FeatureCollection);
}

/** 监听绘制位势高度图层 */
const SplitScreenHeightFieldHandle = async (params: ModeCompareEvents["SplitScreenHeightField"]) => {
  const tag = newMapList.value.length !== params.length ? await waitForNonEmptyArray(newMapList.value, params.length) : true;
  if (tag)
    params.forEach((item, index) => {
      if (item.url.length)
        fetch(item.url).then(response => response.json()).then(async data => {
          // 500hPa 588标红
          if (item.height === 500) data.features.forEach((item: { [key: string]: any }) => {
            if (item.properties && item.properties.value === 588) {
              item.properties.color = "#FF0000";
              item.properties.lineWidth = 4;
            }
          });

          let drawData = data;
          newMapList.value[index].geoHeight = {
            url: item.url, height: item.height, showText: "，" + (item.height === 0 ? "海平面气压等值线" : (item.height + "hPa高度等值线")), origin: drawData
          };
          if (maskDisplay.value) {
            newMapList.value[index].geoHeight!.clip = await geojsonClip(data, "IntelligentGrid");
            drawData = newMapList.value[index].geoHeight!.clip;
          }

          if (newMapList.value[index].map.getSource("geoHeightSource"))
            (newMapList.value[index].map.getSource("geoHeightSource") as mapboxgl.GeoJSONSource).setData(drawData);
          else {
            newMapList.value[index].map.addSource("geoHeightSource", { type: "geojson", data: drawData });
            newMapList.value[index].map.addLayer({
              id: "geoHeightLine", type: "line", source: "geoHeightSource", layout: { visibility: heightSelectLevel.value !== undefined ? "visible" : "none" },
              paint: { "line-color": ["coalesce", ["get", "color"], '#0000FF'], "line-width": ["coalesce", ["get", "lineWidth"], 2] }
            });
            newMapList.value[index].map.addLayer({
              id: "geoHeightText", type: "symbol", source: "geoHeightSource",
              paint: { "text-color": ["coalesce", ["get", "color"], '#0000FF'], "text-halo-color": "white", "text-halo-width": 2 },
              layout: {
                visibility: heightSelectLevel.value !== undefined ? "visible" : "none", "symbol-placement": "line",
                "text-allow-overlap": true, "symbol-spacing": 500, "text-field": ["coalesce", ["get", "value"], '']
              }
            });
          }
        }).catch(error => {
          if (newMapList.value[index].map.getSource("geoHeightSource"))
            (newMapList.value[index].map.getSource("geoHeightSource") as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] });
        });
      else if (newMapList.value[index].map.getSource("geoHeightSource"))
        (newMapList.value[index].map.getSource("geoHeightSource") as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] });
    });
};

/** 监听绘制风场图层 */
const SplitScreenWindFieldHandle = async (params: ModeCompareEvents["SplitScreenWindField"]) => {
  const tag = newMapList.value.length !== params.length ? await waitForNonEmptyArray(newMapList.value, params.length) : true;
  if (tag)
    params.forEach((item, index) => {
      newMapList.value[index].windHeight = item;
      if (gridWind.value) refreshWindField(newMapList.value[index].map, index);
    });
};

// 轮询等待
async function waitForNonEmptyArray<T>(array: T[], tagLength: number): Promise<boolean> {
  let tag = 0;
  while (true) {
    if (array.length === tagLength) return true; // 数组有长度，返回成功
    if (tag >= 10) return false; // 超时，返回失败
    tag++;
    await new Promise(resolve => setTimeout(resolve, 100));
  }
}

/** 监听设置地图位置 */
const SplitScreenPositionSetHandle = (params: ModeCompareEvents["SplitScreenPositionSet"]) => {
  mapProps.value.center = new mapboxgl.LngLat(params.position[0], params.position[1]);
  mapProps.value.zoom = params.zoom - 1;
  newMapList.value.forEach((item) => {
    item.map.flyTo({ center: params.position, zoom: params.zoom - 1 });
  });
};

/** 移除多分屏 */
const ExitSplitScreenHandle = () => {
  newMapList.value.forEach(item => { if (item.map) item.map.remove() });
  newMapList.value = [];
  displayStatus.value = "single";
};

/** 
 * 指定地图绘制切片纹理图
 * @param index 地图索引
 */
// firstRender: 初次渲染完成后抛出消息
async function refreshSliceLayer(e: { target: mapboxgl.Map }, index: number, updateColorBar?: boolean) {
  const params = newMapList.value[index].sliceInfo;
  const map = e.target;
  const urlList = (params.texClipParams.coeffX && params.texClipParams.coeffX.length) ?
    calcSliceUrl(map, params.URL, params.texClipParams) : [params.URL.replace("{level}", "0").replace("{index}", "0")]; // 特殊处理 仅1级的时候

  // 初始化状态
  const statusParams: { visualEffect: number, isNearest?: boolean, mask?: boolean } = { visualEffect: linearFillColor.value ? 1 : 0, mask: maskDisplay.value ?? undefined };
  if (params.isNearest !== undefined) statusParams.isNearest = params.isNearest;

  const tempCurrentLayer: singleCustomLayer[] = [];
  let layerLoadFinishCounter: number = 0; // 图层加载完成 计数器
  urlList.forEach((url) => {
    let tag = false;
    for (let i = 0; i < newMapList.value[index].sliceLayer.length; i++) {
      if (newMapList.value[index].sliceLayer[i].id === url) {
        tempCurrentLayer.push(newMapList.value[index].sliceLayer[i] as singleCustomLayer);
        layerLoadFinishCounter++;
        if (gridData.value && urlList.length === layerLoadFinishCounter) refreshGrid(map, tempCurrentLayer);
        tag = true;
        break;
      }
    }

    if (!tag) { // 新增
      const idx = newMapList.value[index].usedTexChannel.findIndex((item) => item === false);
      newMapList.value[index].usedTexChannel[idx] = true;
      const webglProperties = new singleCustomLayer(url, url, "splitScreenSliceLayer", [idx + 1], () => {
        if (specifiedAlpha.value.length) // 初始化透明度
          specifiedAlpha.value.forEach((item) => {
            webglProperties.changeSpecifiedOpacity(item.index, item.alpha);
          });
        layerLoadFinishCounter++;
        if (gridData.value && urlList.length === layerLoadFinishCounter) refreshGrid(map, tempCurrentLayer);

        // 更新色标
        if (updateColorBar && webglProperties.image) {
          const splitId = webglProperties.id.split("/");
          const splitIdIdx = splitId.findIndex(item => item === "TUM_SLICE");
          const ColorBarDataId = splitIdIdx !== -1 ? `${splitId[splitIdIdx]}_${splitId[splitIdIdx + 2]}` : "";

          if (displayStatus.value !== "multiElement") {
            if (!ColorBarData.value || ColorBarDataId !== ColorBarData.value.id) {
              const codeLabels = Object.keys(webglProperties.image.colorCodeData).sort((a: string, b: string) => parseFloat(a) - parseFloat(b));
              const codeValues: string[] = [];
              codeLabels.forEach(item => { codeValues.push(webglProperties.image!.colorCodeData[item]) });
              codeLabels.forEach((item, index) => {
                const num = parseFloat(item);
                if (!isNaN(num)) {
                  const tempNum = parseFloat(num.toFixed(1));
                  codeLabels[index] = tempNum % 1 === 0 ? tempNum.toFixed(0) : tempNum.toString();
                }
              });
              ColorBarData.value = { id: ColorBarDataId, codeKeys: codeLabels, codeColor: codeValues, colorOpacity: Array.from({ length: codeValues.length }, () => 1), unit: webglProperties.image.dataUnit };
            }
          } else {
            const codeLabels = Object.keys(webglProperties.image.colorCodeData).sort((a: string, b: string) => parseFloat(a) - parseFloat(b));
            const codeValues: string[] = [];
            codeLabels.forEach(item => { codeValues.push(webglProperties.image!.colorCodeData[item]) });
            codeLabels.forEach((item, index) => {
              const num = parseFloat(item);
              if (!isNaN(num)) {
                const tempNum = parseFloat(num.toFixed(1));
                codeLabels[index] = tempNum % 1 === 0 ? tempNum.toFixed(0) : tempNum.toString();
              }
            });

            if (codeValues.length > 20) {
              const splitCodeValues = [], splitCodeLabels = [];
              for (let i = codeValues.length; i > 0; i -= 20) {
                const start = Math.max(0, i - 20);
                splitCodeValues.unshift(codeValues.slice(start, i));
                splitCodeLabels.unshift(codeLabels.slice(start, i));
              }
              ColorBarDataList.value[index] = {
                id: ColorBarDataId, codeKeys: splitCodeLabels, codeColor: splitCodeValues, colorOpacity: Array.from({ length: codeValues.length }, () => 1), unit: webglProperties.image.dataUnit
              };
            } else
              ColorBarDataList.value[index] = {
                id: ColorBarDataId, codeKeys: codeLabels, codeColor: codeValues, colorOpacity: Array.from({ length: codeValues.length }, () => 1), unit: webglProperties.image.dataUnit
              };
          }
        }
      }, statusParams, false);
      map.addLayer(webglProperties, "world_line");
      tempCurrentLayer.push(webglProperties);
    }
  });

  // 移除
  setTimeout(() => {
    newMapList.value[index].sliceLayer.forEach((item) => {
      if (!urlList.includes(item.id)) {
        map.removeLayer(item.id);
        newMapList.value[index].usedTexChannel[item.textureChannel[0] - 1] = false;
      }
    });
    newMapList.value[index].sliceLayer = tempCurrentLayer;
  }, 100);

  // 风场
  if (gridWind.value && newMapList.value[index].windHeight)
    refreshWindField(map, index);
}

/** 刷新风场 */
const refreshWindField = async (map: mapboxgl.Map, index: number) => {
  const windParams = newMapList.value[index].windHeight!;
  const windUrlList = (windParams.texClipParams.coeffX && windParams.texClipParams.coeffX.length) ?
    calcSliceUrl(map, windParams.url, windParams.texClipParams as { coeffX: number[], coeffY: number[] },
      maskDisplay.value ? { minLat: 1.3, maxLat: 25, minLng: 106.1, maxLng: 120.35 } : undefined) :
    [windParams.url.replace("{level}", "0").replace("{index}", "0")]; // 特殊处理 仅1级的时候
  for (let i = 0; i < windUrlList.length; i++) windUrlList[i] = windUrlList[i].replace("{height}", windParams.height.toString());

  const tempWindImage: NewMapListItem["windImage"] = [];
  try {
    for (let windIndex = 0; windIndex < windUrlList.length; windIndex++) {
      let tag = false;

      for (let i = 0; i < newMapList.value[index].windImage.length; i++)
        if (newMapList.value[index].windImage[i].url === windUrlList[windIndex]) {
          tempWindImage.push(newMapList.value[index].windImage[i] as { image: GrayImage, url: string });
          tag = true;
          break;
        }

      if (!tag) {
        const image = await loadImage(windUrlList[windIndex]);
        tempWindImage.push({ image, url: windUrlList[windIndex] });
      }
    }
    newMapList.value[index].windImage = tempWindImage;
    const res = await generateWindFeature(map, tempWindImage, newMapList.value[index].windHeight!.height);

    if (!map.getSource("GridWindSource")) {
      map.addSource("GridWindSource", { type: "geojson", data: res });
      map.addLayer({
        id: "GridWindLayer", source: "GridWindSource", type: "symbol",
        layout: { "icon-image": ['coalesce', ['get', 'imgKey'], ''], "icon-rotate": ['coalesce', ['get', 'rotate'], 0], "icon-allow-overlap": true }
      });
    } else
      (map.getSource("GridWindSource") as mapboxgl.GeoJSONSource).setData(res);
  } catch (error) { // 图片加载失败
    if (map.getSource("GridWindSource"))
      (map.getSource("GridWindSource") as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] }); // 清空风场
  }

  // 生成风场格点feature
  async function generateWindFeature(map: mapboxgl.Map, tempWindImage: NewMapListItem["windImage"], level: number): Promise<GeoJSON.FeatureCollection<GeoJSON.Point, GeoJSON.GeoJsonProperties>> {
    const imageList: GrayImage[] = [];
    for (let i = 0; i < tempWindImage.length; i++)
      if (tempWindImage[i] && tempWindImage[i].image) imageList.push(tempWindImage[i].image!);
    if (!imageList.length) (map.getSource("GridWindSource") as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] }); // 清空风场

    const northeast = map.getBounds().getNorthEast();
    const southwest = map.getBounds().getSouthWest();

    let minLon: number = southwest.lng, maxLon: number = northeast.lng,
      minLat: number = southwest.lat, maxLat: number = northeast.lat;

    if (maskDisplay.value) {
      maxLon = maxLon > 120.35 ? 120.35 : maxLon;
      minLon = minLon < 106.1 ? 106.1 : minLon;
      maxLat = maxLat > 25 ? 25 : maxLat;
      minLat = minLat < 1.3 ? 1.3 : minLat;
    } else {
      maxLon = maxLon > 180 ? 180 : maxLon;
      minLon = minLon < 0 ? 0 : minLon;
      maxLat = maxLat > 90 ? 90 : maxLat;
      minLat = minLat < 0 ? 0 : minLat;
    }


    const leftUp = map.project([minLon, maxLat]);
    const rightDown = map.project([maxLon, minLat]);
    return {
      type: "FeatureCollection", features: await getSliceGridArray({ minLat, maxLat, minLon, maxLon }, leftUp, rightDown,
        imageList[0].yInterval, imageList[0].xInterval, level, imageList, true)
    };
  }
}

// 修改指定色标的透明度
const changeSpecitfiedOpacity = (index: number, value: number, mapIndex?: number) => {
  if (displayStatus.value === "single")
    $Self.ApplyEvents.ModeCompare.emit("ChangeSpecifiedOpacity", { index, alpha: value });
  else {
    if (mapIndex === undefined)
      newMapList.value.forEach((item) => {
        item.sliceLayer.forEach((layer) => layer.changeSpecifiedOpacity(index, value));
      });
    else newMapList.value[mapIndex].sliceLayer.forEach((layer) => layer.changeSpecifiedOpacity(index, value));

    // todo 多要素 specifiedAlpha

    const idx = specifiedAlpha.value.findIndex(item => item.index === index);
    if (value !== 1) {
      if (idx !== -1) specifiedAlpha.value[idx].alpha = value;
      else specifiedAlpha.value.push({ index, alpha: value });
    } else
      if (idx !== -1) specifiedAlpha.value.splice(idx, 1);
  }
};

// 生成颜色阈值工具
const generateColorThresholder = (index: number, colorCodeData: { [key: string]: string }, unit: string) => {
  const colorKeyObj = Object.keys(colorCodeData).sort((a, b) => parseFloat(a) - parseFloat(b));
  const colorLength = colorKeyObj.length;
  const canvas = document.getElementById(index === -1 ? "mode-compare-map-color" : ("mode-compare-map-" + index + "-color")) as HTMLCanvasElement;
  const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;

  if (index === -1 || displayStatus.value === "multiElement") {
    const gradient = ctx.createLinearGradient(0, 0, 0, 360);
    [...colorKeyObj].reverse().forEach((key, i) => {
      gradient.addColorStop(i / (colorLength - 1), colorCodeData[key]);
    });
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 20, 360);
  } else {
    const gradient = ctx.createLinearGradient(0, 0, 360, 0);
    colorKeyObj.forEach((key, i) => {
      gradient.addColorStop(i / (colorLength - 1), colorCodeData[key]);
    });
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 360, 20);
  }

  const mappingFunc = (val: number) => {
    const floorIndex = Math.floor(val / 10), ceilIndex = Math.ceil(val / 10);
    return parseFloat(colorKeyObj[floorIndex]) + (parseFloat(colorKeyObj[ceilIndex]) - parseFloat(colorKeyObj[floorIndex])) * (val - floorIndex * 10) / 10;
  };

  const colorThresholderParams = {
    threshold: parseFloat(colorKeyObj[0]), length: colorLength, valueList: Object.keys(colorCodeData).sort((a, b) => parseFloat(a) - parseFloat(b)),
    mappingFunc, mappingFuncWithUnit: (val: number) => { return parseFloat(mappingFunc(val).toFixed(3)) + unit }
  };

  if (index === -1) colorThresholder.value = colorThresholderParams;
  else newMapList.value[index].colorThresholder = colorThresholderParams;
}

/** 绘制差值纹理图 */
const drawDiffTexture = (index: number, markerLabel: string, customLayerList: CustomLayer[]) => {
  const gridData1 = customLayerList[0].image!.getGridData(), gridData2 = customLayerList[1].image!.getGridData();
  const gridDataDiff: number[] = [];
  gridData1.forEach((num, index) => gridDataDiff.push(parseFloat((num - gridData2[index]).toFixed(2))));

  const minValue = -Math.max(customLayerList[0].image!.maxValue, customLayerList[1].image!.maxValue),
    maxValue = Math.max(customLayerList[0].image!.maxValue, customLayerList[1].image!.maxValue), digits = 2, scale = 100;

  const imageInfo = customLayerList[0].image!;
  const gridImageData: number[] = new Array(imageInfo.gridWidth * imageInfo.gridHeight * 4).fill(0);

  let maxDiffAbs = 0;
  gridDataDiff.forEach((num, gridIndex) => {
    const tempNum = (num - minValue) * scale;
    if (Math.abs(num) > maxDiffAbs) maxDiffAbs = Math.abs(num);

    const r = Math.floor(tempNum / 256 / 256);
    const g = Math.floor((tempNum - r * 256 * 256) / 256);
    const b = tempNum - r * 256 * 256 - g * 256;
    const rowIndex = (imageInfo.gridHeight - 1) - Math.floor(gridIndex / imageInfo.gridWidth), colIndex = gridIndex % imageInfo.gridWidth;
    const index = (rowIndex * imageInfo.gridWidth + colIndex) * 4;

    gridImageData[index] = r, gridImageData[index + 1] = g, gridImageData[index + 2] = b, gridImageData[index + 3] = 255;
  });

  const colorCode: { [key: number]: string } = {};
  const colorList = ["#993301", "#ff3333", "#fd8784", "#ffdca8", "#fcfe9c", "#dfffd9", "#f2ffff", "#97fff4", "#3ca0f0", "#1a5ca6", "#80007c"]
  const colorInterval = maxDiffAbs / 10;
  for (let i = -5; i <= 5; i++)
    colorCode[i * colorInterval] = colorList[i + 5];

  const grayImage = new GrayImageByValue(
    {
      startLat: imageInfo.startLat, startLon: imageInfo.startLon, endLat: imageInfo.endLat, endLon: imageInfo.endLon,
      latInterval: imageInfo.yInterval, lonInterval: imageInfo.xInterval, latLength: imageInfo.gridHeight, lonLength: imageInfo.gridWidth
    },
    new ImageData(new Uint8ClampedArray(gridImageData), imageInfo.gridWidth, imageInfo.gridHeight),
    scale, digits, colorCode, minValue, maxValue, false
  );

  const customLayer = new CustomLayer(grayImage as any, "IntelligentGridLayer", "IntelligentGrid", [2, 3], () => { }, {}, true);
  newMapList.value[index].map.addLayer(customLayer, "world_line");
  newMapList.value[index].layer = customLayer;
  newMapList.value[index].markerInfo = {
    ...newMapList.value[index].markerInfo, markerLabel, unit: customLayerList[0].image?.dataUnit, gridData: gridDataDiff, borderInfo: {
      startLon: grayImage.startLon, endLon: grayImage.endLon, startLat: grayImage.startLat, endLat: grayImage.endLat,
      xInterval: grayImage.xInterval, yInterval: grayImage.yInterval, gridWidth: grayImage.gridWidth
    }
  };
  newMapList.value[index].map.on('mousemove', mousemoveEvent);
  if (customLayer.image) generateColorThresholder(-1, customLayer.image.colorCodeData, customLayerList[0].image!.dataUnit);
};

/** 鼠标移动监听事件(用于marker) */
const mousemoveEvent = (e: mapboxgl.MapMouseEvent & mapboxgl.EventData) => {
  newMapList.value.forEach((item) => {
    if (item.markerInfo.marker && item.markerInfo.borderInfo && item.markerInfo.gridData && item.markerInfo.markerDiv) {
      const border = item.markerInfo.borderInfo;
      if (e.lngLat.lng < border.startLon || e.lngLat.lng > border.endLon || e.lngLat.lat < border.startLat || e.lngLat.lat > border.endLat) {
        item.markerInfo.marker.remove();
        return;
      }

      const lonIndex = Math.round((e.lngLat.lng - border.startLon) / border.xInterval),
        latIndex = Math.round((e.lngLat.lat - border.startLat) / border.yInterval);
      item.markerInfo.markerDiv.innerText = item.markerInfo.markerLabel + "\n" +
        item.markerInfo.gridData[latIndex * border.gridWidth + lonIndex].toFixed(2) + item.markerInfo.unit;
      item.markerInfo.marker.setLngLat([e.lngLat.lng, e.lngLat.lat]);
      item.markerInfo.marker.addTo(item.map); /* Ensure the marker is added to the map. This is safe to call if it's already added. */
    }
  });
};

/** 
 * 指定地图绘制3D
 * @param index 地图索引
 * @param url 纹理图 (不传则清空)
 */
const ThreeModel = ref(); // 三维模型
const threeModelOperation = ref<ThreeModelOperation>();
const draw3D = (index: number, url?: string) => {
  if (url) {
    const texImage = new Image();
    texImage.src = url;
    texImage.setAttribute('crossOrigin', '');
    try {
      texImage.onload = () => {
        const image = new GrayImage(GetBytesFromImage(texImage));
        if (ThreeModel.value) ThreeModel.value.updateUrl(image);
        else {
          ThreeModel.value = new ClassThreeTextureModel(image);
          newMapList.value[index].map.addLayer(ThreeModel.value.TextureCustomLayer);
        }

        // 操作变量赋值
        const St_Lat = image.startLat, St_Lon = image.startLon, End_Lat = image.endLat, End_Lon = image.endLon;
        threeModelOperation.value = {
          St_Lat, St_Lon, End_Lat, End_Lon,
          xySectionInfo: { xMin: St_Lon, xMax: End_Lon, yMin: St_Lat, yMax: End_Lat },
          xSectionVal: [parseFloat(St_Lon.toFixed(2)), parseFloat(End_Lon.toFixed(2))],
          ySectionVal: [parseFloat(St_Lat.toFixed(2)), parseFloat(End_Lat.toFixed(2))],
          zSectionVal: [0, image.altitudeHPa[image.altitudeHPa.length - 1]],
          atmosphereInfo: { min: image.altitudeHPa[0], max: image.altitudeHPa[image.altitudeHPa.length - 1] },
          thresholdInfo: { min: Math.floor(image.minValue), max: Math.ceil(image.maxValue) },
          thresholdVal: Math.floor(image.minValue),
          opacityVal: 0.5
        };
        ThreeModel.value.setThreshold(threeModelOperation.value.thresholdVal);
      };
    } catch (excepiton) {
      ElMessage.error("加载纹理图失败 " + excepiton);
    }
  }
};

/** 调整阈值 */
const changeThreshold = (index: number, value: number) => {
  if (index === -1) {
    const threshold = colorThresholder.value!.mappingFunc(value);
    if (displayStatus.value !== "difference")
      newMapList.value.forEach((item) => {
        if (item.layer) item.layer.changeThreshold(threshold);
      });
    else {
      const diffLayer = newMapList.value[newMapList.value.length - 1].layer;
      if (diffLayer) diffLayer.changeThreshold(threshold);
    }
  }
  else
    if (newMapList.value[index].colorThresholder && newMapList.value[index].layer) {
      const threshold = newMapList.value[index].colorThresholder!.mappingFunc(value);
      newMapList.value[index].layer?.changeThreshold(threshold);
    }
};

/** 以下为三维面板处理方法 */
// 调整X轴截面
const changeXSectionVal = (val: [number, number]) => {
  if (threeModelOperation.value) {
    ThreeModel.value.setProps("xClippingPlaneMin",
      (val[0] - threeModelOperation.value.xySectionInfo.xMin) /
      (threeModelOperation.value.xySectionInfo.xMax - threeModelOperation.value.xySectionInfo.xMin));
    ThreeModel.value.setProps("xClippingPlaneMax",
      (val[1] - threeModelOperation.value.xySectionInfo.xMin) /
      (threeModelOperation.value.xySectionInfo.xMax - threeModelOperation.value.xySectionInfo.xMin));
  }
};

// 调整Y轴截面
const changeYSectionVal = (val: [number, number]) => {
  if (threeModelOperation.value) {
    ThreeModel.value.setProps("zClippingPlaneMax",
      1 - (val[0] - threeModelOperation.value.xySectionInfo.yMin) /
      (threeModelOperation.value.xySectionInfo.yMax - threeModelOperation.value.xySectionInfo.yMin));
    ThreeModel.value.setProps("zClippingPlaneMin",
      1 - (val[1] - threeModelOperation.value.xySectionInfo.yMin) /
      (threeModelOperation.value.xySectionInfo.yMax - threeModelOperation.value.xySectionInfo.yMin));
  }
};

// 调整Z轴截面
const changeZSectionVal = (val: [number, number]) => {
  if (threeModelOperation.value) {
    const drawHeight = ThreeModel.value.guiControls.drawHeight;
    const bottomHeight = atmosphericPressure_to_height(
      threeModelOperation.value.atmosphereInfo.max - val[0] + threeModelOperation.value.atmosphereInfo.min
    );
    const topHeight = atmosphericPressure_to_height(
      threeModelOperation.value.atmosphereInfo.max - val[1] + threeModelOperation.value.atmosphereInfo.min
    );
    ThreeModel.value.setProps("yClippingPlaneMin", bottomHeight / drawHeight);
    ThreeModel.value.setProps("yClippingPlaneMax", topHeight / drawHeight);
  }
};

// 绘制截面/截取区域/单点
const drawHandle = (mode: string) => {
  mapboxDraw.value?.changeMode(mode);
};

// 清除绘制
const trashHandle = () => {
  mapboxDraw.value?.trash();
};

// 调整阈值
const change3DThreshold = (val: number) => {
  if (ThreeModel.value && ThreeModel.value.setThreshold)
    ThreeModel.value.setThreshold(val);
};

// 调整透明度
const changeOpacity = (val: number) => {
  ThreeModel.value.setOpacity(val);
};

// 切换高度层
const changeLevel = (index: number) => {
  const level = newMapList.value[index].level;
  const heightIndex = heightOption.value.length - 1 - heightOption.value.findIndex((height: number) => height === level);
  const newColorCode = newMapList.value[index].layer?.changeLevelIndex(heightIndex);
  if (newColorCode)
    generateColorThresholder(index, newColorCode, newMapList.value[index].layer?.image?.dataUnit!);
};

// 切换高度截面
const switchHeightCutting = () => {
  isHeightCutting.value = !isHeightCutting.value;
  if (isHeightCutting.value) ThreeModel.value.switchHeightCutting(2, 1000, 15000, 1500);
  else ThreeModel.value.switchHeightCutting(0, 0, 0, 0);
};

return (_ctx: any,_cache: any) => {
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (displayStatus.value !== 'single')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["mode-compare-map-box", 'mode-compare-map-box-' + modeCompareMapNum.value + 'map'])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...new Array(modeCompareMapNum.value).keys()], (index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["mode-compare-map-box-single", 'mode-compare-map-box_' + index])
              }, [
                _createElementVNode("div", {
                  id: 'mode-compare-map-' + index,
                  class: "mode-compare-map-box-single-item"
                }, null, 8, _hoisted_2),
                (displayStatus.value !== 'multiLevel')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("span", null, _toDisplayString(newMapList.value[index] ? newMapList.value[index].showText : "--"), 1)
                    ]))
                  : _createCommentVNode("", true),
                (displayStatus.value !== 'multiLevel')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", null, _toDisplayString(newMapList.value[index] ?
              (newMapList.value[index].bottomShowText +
                ((_unref(heightSelectLevel) !== undefined && newMapList.value[index].geoHeight) ? newMapList.value[index].geoHeight!.showText
                  : ""))
              : "--"), 1)
                    ]))
                  : _createCommentVNode("", true),
                (newMapList.value[index] && newMapList.value[index].is3D && threeModelOperation.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "three-dimension-control-panel-text" }, "剖面", -1)),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_el_popover, {
                          placement: "left",
                          effect: "dark",
                          teleported: false,
                          "popper-style": "min-width: 0; width: none; padding-top: 2px; padding-bottom: 2px;"
                        }, {
                          reference: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("div", { class: "three-dimension-control-panel-button" }, [
                              _createElementVNode("img", {
                                src: _imports_0,
                                title: "X轴截面"
                              })
                            ], -1)
                          ]))]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_slider, {
                              modelValue: threeModelOperation.value.xSectionVal,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((threeModelOperation.value.xSectionVal) = $event)),
                              range: true,
                              min: parseFloat(threeModelOperation.value.xySectionInfo.xMin.toFixed(2)),
                              max: parseFloat(threeModelOperation.value.xySectionInfo.xMax.toFixed(2)),
                              style: {"width":"90px"},
                              "format-tooltip": (lng) => { return lng + '°E'; },
                              step: 0.01,
                              onInput: changeXSectionVal,
                              class: "three-dimension-slider"
                            }, null, 8, ["modelValue", "min", "max", "format-tooltip"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_popover, {
                          placement: "left",
                          effect: "dark",
                          teleported: false,
                          "popper-style": "min-width: 0; width: none; padding-left: 2px; padding-right: 2px;"
                        }, {
                          reference: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("div", { class: "three-dimension-control-panel-button" }, [
                              _createElementVNode("img", {
                                src: _imports_1,
                                title: "Y轴截面"
                              })
                            ], -1)
                          ]))]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_slider, {
                              modelValue: threeModelOperation.value.ySectionVal,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((threeModelOperation.value.ySectionVal) = $event)),
                              range: true,
                              vertical: "",
                              height: "90px",
                              min: parseFloat(threeModelOperation.value.xySectionInfo.yMin.toFixed(2)),
                              max: parseFloat(threeModelOperation.value.xySectionInfo.yMax.toFixed(2)),
                              "format-tooltip": (lat) => { return lat + '°N'; },
                              step: 0.01,
                              onInput: changeYSectionVal,
                              class: "three-dimension-slider-vertical"
                            }, null, 8, ["modelValue", "min", "max", "format-tooltip"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_popover, {
                          placement: "left",
                          effect: "dark",
                          teleported: false,
                          "popper-style": "min-width: 0; width: none; padding-left: 2px; padding-right: 2px;"
                        }, {
                          reference: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("div", { class: "three-dimension-control-panel-button" }, [
                              _createElementVNode("img", {
                                src: _imports_2,
                                title: "Z轴截面"
                              })
                            ], -1)
                          ]))]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_slider, {
                              modelValue: threeModelOperation.value.zSectionVal,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((threeModelOperation.value.zSectionVal) = $event)),
                              range: true,
                              vertical: "",
                              height: "90px",
                              min: threeModelOperation.value.atmosphereInfo.min,
                              max: threeModelOperation.value.atmosphereInfo.max,
                              onInput: changeZSectionVal,
                              class: "three-dimension-slider-vertical",
                              "format-tooltip": (pre) => { return (threeModelOperation.value!.atmosphereInfo.min + threeModelOperation.value!.atmosphereInfo.max - pre) + 'hPa'; }
                            }, null, 8, ["modelValue", "min", "max", "format-tooltip"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", {
                          class: _normalizeClass(["three-dimension-control-panel-button", { 'three-dimension-control-panel-button-select': isHeightCutting.value }]),
                          onClick: switchHeightCutting
                        }, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("span", {
                            class: "icon iconfont icon-duoceng",
                            title: "高度截面"
                          }, null, -1)
                        ]))], 2),
                        _createElementVNode("div", {
                          class: "three-dimension-control-panel-button",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (drawHandle('draw_polygon')))
                        }, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("img", {
                            src: _imports_3,
                            title: "区域选取"
                          }, null, -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "three-dimension-control-panel-button",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (drawHandle('draw_line_string')))
                        }, [...(_cache[13] || (_cache[13] = [
                          _createElementVNode("img", {
                            src: _imports_4,
                            title: "截面选取"
                          }, null, -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "three-dimension-control-panel-button",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (trashHandle()))
                        }, [...(_cache[14] || (_cache[14] = [
                          _createElementVNode("img", {
                            src: _imports_5,
                            title: "移除"
                          }, null, -1)
                        ]))])
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "three-dimension-control-panel-text" }, "透明度", -1)),
                      _createVNode(_component_el_slider, {
                        modelValue: threeModelOperation.value.opacityVal,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((threeModelOperation.value.opacityVal) = $event)),
                        vertical: "",
                        min: 0,
                        max: 1,
                        step: 0.01,
                        height: "80px",
                        onInput: changeOpacity,
                        class: "three-dimension-slider-vertical"
                      }, null, 8, ["modelValue"]),
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "three-dimension-control-panel-text" }, "阈值", -1)),
                      _createVNode(_component_el_slider, {
                        modelValue: threeModelOperation.value.thresholdVal,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((threeModelOperation.value.thresholdVal) = $event)),
                        vertical: "",
                        min: threeModelOperation.value.thresholdInfo.min,
                        max: threeModelOperation.value.thresholdInfo.max,
                        height: "80px",
                        onInput: change3DThreshold,
                        class: "three-dimension-slider-vertical"
                      }, null, 8, ["modelValue", "min", "max"])
                    ]))
                  : _createCommentVNode("", true),
                (newMapList.value[index] && newMapList.value[index].level)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (displayStatus.value === 'multiLevel')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_select, {
                              onChange: ($event: any) => (changeLevel(index)),
                              modelValue: newMapList.value[index].level,
                              "onUpdate:modelValue": ($event: any) => ((newMapList.value[index].level) = $event)
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(heightOption.value, (height) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: height,
                                    value: height,
                                    label: height + 'hPa'
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["onChange", "modelValue", "onUpdate:modelValue"]),
                            _createElementVNode("div", _hoisted_8, [
                              (newMapList.value[index] && newMapList.value[index].colorThresholder)
                                ? (_openBlock(), _createBlock(_component_el_slider, {
                                    key: 0,
                                    step: 0.01,
                                    max: (newMapList.value[index].colorThresholder!.length - 1) * 10,
                                    "format-tooltip": newMapList.value[index].colorThresholder!.mappingFuncWithUnit,
                                    modelValue: newMapList.value[index].colorThresholder!.threshold,
                                    "onUpdate:modelValue": ($event: any) => ((newMapList.value[index].colorThresholder!.threshold) = $event),
                                    onInput: ($event: any) => (changeThreshold(index, newMapList.value[index].colorThresholder!.threshold))
                                  }, null, 8, ["max", "format-tooltip", "modelValue", "onUpdate:modelValue", "onInput"]))
                                : _createCommentVNode("", true),
                              (newMapList.value[index] && newMapList.value[index].colorThresholder)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(newMapList.value[index].colorThresholder?.valueList, (value, thresholdIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "mode-compare-box-text-color-threshold-text",
                                      style: _normalizeStyle({ left: thresholdIndex * (360 / (newMapList.value[index].colorThresholder!.length - 1)) + 'px' })
                                    }, _toDisplayString(parseFloat(value).toFixed(1)), 5))
                                  }), 256))
                                : _createCommentVNode("", true),
                              _createElementVNode("canvas", {
                                id: 'mode-compare-map-' + index + '-color',
                                height: "20",
                                width: "360"
                              }, null, 8, _hoisted_9)
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      (displayStatus.value === 'multiElement')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (newMapList.value[index] && newMapList.value[index].colorThresholder)
                              ? (_openBlock(), _createBlock(_component_el_slider, {
                                  key: 0,
                                  step: 0.01,
                                  vertical: "",
                                  max: (newMapList.value[index].colorThresholder!.length - 1) * 10,
                                  "format-tooltip": newMapList.value[index].colorThresholder!.mappingFuncWithUnit,
                                  modelValue: newMapList.value[index].colorThresholder!.threshold,
                                  "onUpdate:modelValue": ($event: any) => ((newMapList.value[index].colorThresholder!.threshold) = $event),
                                  onInput: ($event: any) => (changeThreshold(index, newMapList.value[index].colorThresholder!.threshold))
                                }, null, 8, ["max", "format-tooltip", "modelValue", "onUpdate:modelValue", "onInput"]))
                              : _createCommentVNode("", true),
                            (newMapList.value[index] && newMapList.value[index].colorThresholder)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(newMapList.value[index].colorThresholder?.valueList, (value, thresholdIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "mode-compare-box-color-threshold-text",
                                    style: _normalizeStyle({ top: (360 - thresholdIndex * (360 / (newMapList.value[index].colorThresholder!.length - 1))) + 'px' })
                                  }, _toDisplayString(parseFloat(value).toFixed(1)), 5))
                                }), 256))
                              : _createCommentVNode("", true),
                            _createElementVNode("canvas", {
                              id: 'mode-compare-map-' + index + '-color',
                              height: "360",
                              width: "20"
                            }, null, 8, _hoisted_11)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (displayStatus.value === 'multiElement' && ColorBarDataList.value[index])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (ColorBarDataList.value[index].colorOpacity.length > 20)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ColorBarDataList.value[index].codeColor, (splitCodeColor) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitCodeColor, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "color-item",
                                      style: _normalizeStyle({ background: item })
                                    }, null, 4))
                                  }), 256))
                                ]))
                              }), 256))
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ColorBarDataList.value[index].codeKeys, (splitCodeKeys, splitIndex) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitCodeKeys, (item, idx) => {
                                    return (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _createVNode(_component_el_popover, {
                                        placement: "left",
                                        width: 200,
                                        "hide-after": 0
                                      }, {
                                        reference: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(item), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_slider, {
                                            modelValue: ColorBarDataList.value[index].colorOpacity[splitIndex * 20 + idx],
                                            "onUpdate:modelValue": ($event: any) => ((ColorBarDataList.value[index].colorOpacity[splitIndex * 20 + idx]) = $event),
                                            max: 1,
                                            step: 0.01,
                                            size: "small",
                                            onChange: ($event: any) => (changeSpecitfiedOpacity(idx, ColorBarDataList.value[index].colorOpacity[splitIndex * 20 + idx], index))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  }), 256))
                                ]))
                              }), 256))
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ColorBarDataList.value[index].codeColor, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "color-item",
                                  style: _normalizeStyle({ background: item as string })
                                }, null, 4))
                              }), 256))
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ColorBarDataList.value[index].codeKeys, (item, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "color-code-item",
                                  style: _normalizeStyle({ height: (ColorBarDataList.value[index].codeKeys.length > 39 ? (780 / ColorBarDataList.value[index].codeKeys.length) : 20) + 'px' })
                                }, [
                                  _createVNode(_component_el_popover, {
                                    placement: "left",
                                    width: 200,
                                    "hide-after": 0
                                  }, {
                                    reference: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(item), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_slider, {
                                        modelValue: ColorBarDataList.value[index].colorOpacity[idx],
                                        "onUpdate:modelValue": ($event: any) => ((ColorBarDataList.value[index].colorOpacity[idx]) = $event),
                                        max: 1,
                                        step: 0.01,
                                        size: "small",
                                        onChange: ($event: any) => (changeSpecitfiedOpacity(idx, ColorBarDataList.value[index].colorOpacity[idx]))
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 4))
                              }), 256))
                            ])
                          ], 64))
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 256))
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (ColorBarData.value && displayStatus.value !== 'multiElement')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["color-bar-box", { 'color-bar-box-split-screen': displayStatus.value !== 'single' }])
        }, [
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ColorBarData.value.codeColor, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle({ background: item as string })
              }, null, 4))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ColorBarData.value.codeKeys, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle({ height: (ColorBarData.value.codeKeys.length > 39 ? (780 / ColorBarData.value.codeKeys.length) : 20) + 'px' })
              }, [
                _createVNode(_component_el_popover, {
                  placement: "left",
                  width: 200,
                  "hide-after": 0
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(ColorBarData.value.windLabels ? ColorBarData.value.windLabels[index] : item), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_slider, {
                      modelValue: ColorBarData.value.colorOpacity[index],
                      "onUpdate:modelValue": ($event: any) => ((ColorBarData.value.colorOpacity[index]) = $event),
                      max: 1,
                      step: 0.01,
                      size: "small",
                      onChange: ($event: any) => (changeSpecitfiedOpacity(index, ColorBarData.value.colorOpacity[index]))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1024),
                (ColorBarData.value.windLabels && index !== 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item), 1))
                  : _createCommentVNode("", true)
              ], 4))
            }), 256))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})